export var InterFrameMessageIds;
(function (InterFrameMessageIds) {
    InterFrameMessageIds.DESIGNER_LOADED = 'designerLoaded';
    InterFrameMessageIds.INITIALIZE_DESIGNER = 'initializeDesigner';
    InterFrameMessageIds.DESIGNER_READY = 'designerReady';
    InterFrameMessageIds.DESIGNER_FOCUS = 'designerFocus';
})(InterFrameMessageIds || (InterFrameMessageIds = {}));
export var DragHelper;
(function (DragHelper) {
    const SYM_DRAG_DATA = 'gx-drag-data';
    DragHelper.GX_DESIGNER_DRAG_FORMAT = 'gx-designer/drag-data';
    function hasDragData(win) {
        return !!win[SYM_DRAG_DATA];
        //return !!dt.getData(GX_DESIGNER_DRAG_FORMAT);
    }
    DragHelper.hasDragData = hasDragData;
    function setExternalDragData(win, options) {
        win[SYM_DRAG_DATA] = options;
        //dt.setData(GX_DESIGNER_DRAG_FORMAT, JSON.stringify({ data: options, isCopy: false, isInternal: false } as DragData));
    }
    DragHelper.setExternalDragData = setExternalDragData;
    function setInternalDragData(win, nodeIds, isCopy) {
        win[SYM_DRAG_DATA] = { data: nodeIds, isCopy, isInternal: true };
        //dt.setData(GX_DESIGNER_DRAG_FORMAT, JSON.stringify({ data: nodeIds, isCopy, isInternal: true } as DragData));
    }
    DragHelper.setInternalDragData = setInternalDragData;
    function getDragData(win) {
        //let value = dt.getData(GX_DESIGNER_DRAG_FORMAT);
        let value = win[SYM_DRAG_DATA];
        if (value) {
            //let data = JSON.parse(value) as DragData;
            let data = value;
            data.isCopy = !!data.isCopy;
            data.isInternal = !!data.isInternal;
            return data;
        }
    }
    DragHelper.getDragData = getDragData;
})(DragHelper || (DragHelper = {}));
//# sourceMappingURL=types.js.map